import { initialState } from '@ispm-client/modules/pathways/store/state';
import {
  CurationInfoForPathwaysActionTypes,
  UpdateBpmnNodesCurationData
} from '../actions';

export function bpmnNodesCurationData(state = initialState.bpmnNodesCurationData, action: UpdateBpmnNodesCurationData):  any {
  switch (action.type) {
    case CurationInfoForPathwaysActionTypes.UPDATE_BPMN_NODES_CURATION_DATA:
      return action.payload.nodes;
    default: {
      return state;
    }
  }
}
